"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _apolloClient = require("@/apollo/apolloClient");
var _RecruitmentFilter = _interopRequireDefault(require("./components/RecruitmentFilter"));
var _recruitmentMutation = require("@/apollo/mutations/recruitment-mutation");
var _timeUtil = require("@/utils/time-util");
var _auth = require("@/utils/auth");
var _appUtil = require("@/utils/app-util");
var _v = _interopRequireDefault(require("uuid/v4"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Pagination from '@/components/Pagination'
var _default = exports.default = {
  components: {
    RecruitmentFilter: _RecruitmentFilter.default
  },
  data: function data() {
    return {
      waitDialogVisible: false
    };
  },
  computed: {
    recruitments: function recruitments() {
      return this.$store.getters.recruitments;
    },
    currentPage: function currentPage() {
      return this.$store.getters.page_top;
    },
    maxPage: function maxPage() {
      return this.$store.getters.page_last;
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _t;
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return this.$store.dispatch('recruitment/setPageTop', 0);
          case 1:
            _context.next = 2;
            return this.$store.dispatch('recruitment/fetchRecruitments', (0, _auth.getUUID)());
          case 2:
            _context.next = 3;
            return (0, _appUtil.checkReadingFlag)(true);
          case 3:
            _t = _context.sent;
            if (!(_t === true)) {
              _context.next = 4;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function () {
    var _beforeDestroy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _t2;
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return (0, _appUtil.checkReadingFlag)(false);
          case 1:
            _t2 = _context2.sent;
            if (!(_t2 === true)) {
              _context2.next = 2;
              break;
            }
            this.$store.dispatch('app/setKey', (0, _v.default)());
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function beforeDestroy() {
      return _beforeDestroy.apply(this, arguments);
    }
    return beforeDestroy;
  }(),
  methods: {
    displayDateTime: function displayDateTime(dateTime, format) {
      return (0, _timeUtil.displayDateTime)(dateTime, format);
    },
    goToEdit: function goToEdit(id) {
      return this.$router.push({
        name: 'RecruitmentEdit',
        params: {
          id: id
        }
      });
    },
    goToMessage: function goToMessage(id) {
      (0, _auth.setMessageMode)('INDEX');
      (0, _auth.setRecruitmentID)(id);
      return this.$router.push({
        name: 'RecruitmentMessage',
        params: {
          id: id
        }
      });
    },
    goToRelease: function () {
      var _goToRelease = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, is_active) {
        var _this = this;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.waitDialogVisible = true;
              _context3.next = 1;
              return _apolloClient.apolloClient.mutate({
                mutation: _recruitmentMutation.UPDATE_RECRUITMENT_ACTIVE,
                variables: {
                  id: id,
                  is_active: !is_active // 公開フラグ（true = 公開、false = 非公開）
                }
              }).then(function (result) {
                _this.waitDialogVisible = false;
                _apolloClient.apolloClient.resetStore();
                console.log('recruitmentResolve');
                var resultRecruitment = result.data.update_recruitment_info.returning[0];
                _this.$router.go({
                  path: _this.$router.currentRoute.path,
                  force: true
                });
                return Promise.resolve(resultRecruitment);
              }).catch(function (error) {
                _this.waitDialogVisible = false;
                console.log('recruitmentError');
                return Promise.reject(error);
              });
            case 1:
              return _context3.abrupt("return", _context3.sent);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function goToRelease(_x, _x2) {
        return _goToRelease.apply(this, arguments);
      }
      return goToRelease;
    }(),
    goToConfirmation: function goToConfirmation(id) {
      return this.$router.push({
        name: 'RecruitmentDetail',
        params: {
          id: id
        }
      });
    },
    goTopPage: function () {
      var _goTopPage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return this.$store.dispatch('recruitment/setPageTop', 0);
            case 1:
              _context4.next = 2;
              return this.$store.dispatch('recruitment/fetchRecruitments', (0, _auth.getUUID)());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function goTopPage() {
        return _goTopPage.apply(this, arguments);
      }
      return goTopPage;
    }(),
    goPrePage: function () {
      var _goPrePage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var pre;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 1;
              return this.$store.dispatch('recruitment/getPageTop');
            case 1:
              pre = _context5.sent;
              if (!(pre > 0)) {
                _context5.next = 3;
                break;
              }
              _context5.next = 2;
              return this.$store.dispatch('recruitment/setPageTop', pre - 1);
            case 2:
              _context5.next = 3;
              return this.$store.dispatch('recruitment/fetchRecruitments', (0, _auth.getUUID)());
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function goPrePage() {
        return _goPrePage.apply(this, arguments);
      }
      return goPrePage;
    }(),
    goNextPage: function () {
      var _goNextPage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var next, last, _t3;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 1;
              return this.$store.dispatch('recruitment/getPageTop');
            case 1:
              next = _context6.sent;
              _t3 = Math;
              _context6.next = 2;
              return this.$store.dispatch('recruitment/getPageLast');
            case 2:
              last = _t3.floor.call(_t3, _context6.sent);
              if (!(last > next)) {
                _context6.next = 4;
                break;
              }
              _context6.next = 3;
              return this.$store.dispatch('recruitment/setPageTop', next + 1);
            case 3:
              _context6.next = 4;
              return this.$store.dispatch('recruitment/fetchRecruitments', (0, _auth.getUUID)());
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function goNextPage() {
        return _goNextPage.apply(this, arguments);
      }
      return goNextPage;
    }(),
    goLastPage: function () {
      var _goLastPage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var last, _t4;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _t4 = Math;
              _context7.next = 1;
              return this.$store.dispatch('recruitment/getPageLast');
            case 1:
              last = _t4.floor.call(_t4, _context7.sent);
              _context7.next = 2;
              return this.$store.dispatch('recruitment/setPageTop', last);
            case 2:
              _context7.next = 3;
              return this.$store.dispatch('recruitment/fetchRecruitments', (0, _auth.getUUID)());
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function goLastPage() {
        return _goLastPage.apply(this, arguments);
      }
      return goLastPage;
    }()
  }
};